import * as angular from 'angular';

(function () {
    'use strict';
    angular.module('app').factory('MarketsMessages', marketMessagesService);

    function marketMessagesService($resource, API_URL) {
        return $resource(
            API_URL.MARKET_MESSAGES + '' + '/current',
            {},
            {
                archived: {
                    method: 'GET',
                    url: API_URL.MARKET_MESSAGES + '/archive',
                    params: { year: '@year', month: '@month' }
                },
                details: {
                    method: 'GET',
                    url: API_URL.MARKET_MESSAGES + '/marketMessageDetails',
                    params: { messageId: '@messageId' }
                }
            }
        );
    }
})();
